import type { ColumnType } from 'antd/lib/table';
import { TFunction } from 'i18next';
import { Activity } from 'src/shared/types/common';

export const activityRegisterColumn = (t: TFunction): ColumnType<Activity> => ({
  title: t('Activity register'),
  key: 'registeredBy',
  render: (_, item) => item.registeredBy,
});
